import Vue from 'vue';
import { apiPath } from '../constants';

const AppObb = Vue.resource(
  `${apiPath}/apps{/packageName}/obb{/mainObbId}/`,
  {},
  {
    attach: {
      method: 'PUT',
      url: `${apiPath}/apps/{packageName}/packages/{packageId}/obb/`,
    },
    detach: {
      method: 'DELETE',
      url: `${apiPath}/apps/{packageName}/packages/{packageId}/obb{/obbId}/`,
    },
  },
);

export default AppObb;
